export default {
      id: "volume-user-usage",
      viewBox: "0 0 26 34",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#volume-user",
      toString: function () {
        return this.url;
      }
    }